<kodit-card-container [showDivider]="false">
  <ng-container card-title>Promet</ng-container>

  <ng-container card-body>
    <p-chart type="bar" [data]="chartData" [options]="chartOptions"></p-chart>
  </ng-container>
</kodit-card-container>
